import React, { useState } from "react";
import styled from "styled-components";
import {Page, PrimaryButton} from "../../components/styled"
import { useLocation,useNavigate } from "react-router-dom";
import CryptidCard from "../../components/shared/cryptidCard";
import useEmblaCarousel from 'embla-carousel-react'
import ArrowLeftSVG from "../../assets/icons/left_arrow.svg";

const PreviewPack = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [currentCard, setCurrentCard] = useState(1);
    const { state } = location;
    const OPTIONS = { 
      align: 'center',
      duration: 20,
    }
    const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS)

    if (!state) {navigate("/packOpen")};
    const {cards} = state;
    const onDone =async () => {
        navigate("/openedPack", {state:{cards}});
    };

     React.useEffect(() => {
            if (!emblaApi) return;
            const onSelect = () => {
              setCurrentCard(emblaApi.selectedScrollSnap() + 1);
            };
            emblaApi.on('select', onSelect);
            onSelect();
          }, [emblaApi]);
   
    return (
        <Page>
          <TopText>
            {currentCard} / {cards.length}
          </TopText>
          <Viewport ref={emblaRef}>
              <Container>
                  {React.Children.toArray(
                      cards.map((card, index) => (
                          <Slide>
                              <div style={{width: "70%", height: "100%", margin:"auto"}}>
                                 <CryptidCard key={index} cryptid={card} />
                              </div>
                          </Slide>
                      ))
                  )}
              </Container>
              <ArrowIcon src={ArrowLeftSVG} onClick={() => {
              if(emblaApi && emblaApi.canScrollPrev()){
                emblaApi.scrollPrev()
              }
            }} style={{left: 0}}/>
            <ArrowIcon src={ArrowLeftSVG} onClick={() =>{
              if(emblaApi && emblaApi.canScrollNext()){
                emblaApi.scrollNext()
              }
            }} style={{right: 0, transform:"rotate(180deg)"}} />
          </Viewport>
            
          <PrimaryButton style={{width:"50%", marginBottom:40}} onClick={onDone}>Skip</PrimaryButton>
        </Page>
    );
};
  const ArrowIcon = styled.img`
  position: absolute;
  top: calc(50% - 25px);
  width: 52px;
  height: 52px;
  z-index: 10;
  `

const Container = styled.div`
  display: flex;
  align-items: center;
  backface-visibility: hidden;
  height: 100%;
  
`
const Slide = styled.div`
  flex: 0 0 100%;
  min-width: 0;
  position: relative;
  padding: 0 8px;
  height: 100%;
`
const Viewport = styled.div`
flex:1;
position:relative;
width:100%;
overflow:hidden
`

const TopText = styled.p`
color:#fff;
font-weight: 500;
font-size: 16px;
text-align: center;
position:absolute;
top:20px
`
export default PreviewPack;